var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "27",
        height: "27",
        viewBox: "0 0 27 27",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M19.9296 3.09531L20.0745 3.11704C20.3622 3.16874 20.64 3.26587 20.8971 3.40499L21.0239 3.4786L21.146 3.55755C21.4272 3.75082 21.6701 3.99527 21.8624 4.27815L26.343 10.8734C26.7251 11.4343 26.8853 12.1165 26.7945 12.7893C26.7032 13.4648 26.3644 14.0826 25.8438 14.5223L25.8382 14.5276L14.0455 24.4141L14.0446 24.413C13.7558 24.6551 13.421 24.8363 13.0595 24.9434C12.6979 25.0505 12.3177 25.0815 11.9433 25.0356C11.5691 24.9896 11.2084 24.8674 10.8835 24.6762C10.5585 24.4848 10.2758 24.2282 10.0541 23.923L1.00324 11.4782C0.602423 10.9271 0.42063 10.2464 0.492884 9.56877C0.565222 8.89103 0.887346 8.26438 1.39557 7.8102L7.33668 2.49462C7.62798 2.23421 7.97196 2.03906 8.34467 1.92179L8.48545 1.88102C8.81552 1.79622 9.15899 1.77371 9.49818 1.8145L19.9296 3.09531Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M13.553 22.2137L18.5424 12.4934L24.3038 13.2008L13.553 22.2137Z",
          fill: "#135EE2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.058 21.8995L2.8138 10.5622L8.57425 11.2695L11.058 21.8995Z",
          fill: "#135EE2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.4201 21.135L10.159 11.4641L16.9556 12.2986L12.4201 21.135Z",
          fill: "#135EE2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8.87046 9.79461L2.98109 9.07149L8.67003 3.98272C8.74944 3.91173 8.84341 3.85858 8.94501 3.82659C9.04655 3.79465 9.15383 3.78465 9.25952 3.79732L13.5767 4.3274L8.87046 9.79461Z",
          fill: "#135EE2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.8118 10.7697L10.6598 10.0143L14.3045 5.78044L16.8118 10.7697Z",
          fill: "#135EE2",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M19.6813 5.07695C19.787 5.09019 19.8894 5.12593 19.9803 5.18156C20.071 5.23711 20.1486 5.31153 20.2084 5.39945L24.4972 11.7133L18.6011 10.9894L15.3641 4.54686L19.6813 5.07695Z",
          fill: "#135EE2",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }